export function importAllImages(r) {
	let images = []
	r.keys().map((item) => {
		images[item.replace('./', '')] = r(item).default
	})
	return images
}
